const app = {
    ai_suggestions: {
        title: "AI suggestions",
        add: "Add {{property}}",
        remove: "Remove suggestion",
        processing: "AI analysis in progress...",
        analyzing: "Processing suggestions...",
    },
    view_in_crm: "View in CRM",
}

export default app
